<template>
  <screen
    v-show="show"
    :screen-info="$t('thingstonote.remove_acc')"
    :can-leave="false"
    @skip="$emit('skip')"
  >
    <div class="animation w-full" ref="animation"></div>
  </screen>
</template>

<script>
import autoNext from '@/mixins/auto-next';
import animation from '@/mixins/animation';
import removeAcc from '@/assets/animations/remove_accessories.json';
import Screen from '../common/Screen.vue';

export default {
  name: 'RemoveAcc',
  components: {
    Screen,
  },
  mixins: [autoNext, animation],
  data: () => ({
    duration: 5,
    audioKey: '5-Remove_accessories',
    animationData: removeAcc,
  }),
};
</script>
